<script setup lang="ts">
import type { PropertyPriceProps } from '.';
import type IntervalInput from '~/components/IntervalInput/Input.vue';

import { propertyPriceInputVariants } from '.';

const props = withDefaults(defineProps<PropertyPriceProps>(), {
	variant: 'primary',
	showActions: false,
	closeOnApply: false
});

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');

const intervalInputRef = ref<InstanceType<typeof IntervalInput> | null>(null);

const emit = defineEmits<{
	apply: [focusNext?: boolean];
	clear: [];
	'update:range': [
		min: number | null | undefined,
		max: number | null | undefined
	];
}>();

function handleRangeUpdate(
	newMin: number | null | undefined,
	newMax: number | null | undefined
) {
	emit('update:range', newMin, newMax);
}

function handleApply(focusNext?: boolean) {
	if (focusNext) {
		emit('apply', true);
		return;
	}

	emit('apply');
}

defineExpose({
	focusFirstInputWhenReady: () =>
		intervalInputRef.value?.focusFirstInputWhenReady()
});
</script>

<template>
	<IntervalInput
		ref="intervalInputRef"
		v-model:min="min"
		v-model:max="max"
		title="Valor de venda"
		unit="currency"
		min-label="Preço mínimo"
		max-label="Preço máximo"
		update-on="blur"
		:show-actions="props.showActions"
		:close-on-apply="props.closeOnApply"
		filter-name="price"
		:variant="props.variant"
		:input-classes="propertyPriceInputVariants({ variant: props.variant })"
		@apply="handleApply"
		@clear="emit('clear')"
		@update:range="handleRangeUpdate"
	/>
</template>
